var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _ellipse, _path17, _path18, _path19, _path20, _ellipse2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9978 29.9978C25.3322 29.9978 29.9967 23.7303 29.9967 15.9989C29.9967 8.26751 25.3322 2 15.9978 2C6.66334 2 1.9989 8.26751 1.9989 15.9989C1.9989 23.7303 6.66334 29.9978 15.9978 29.9978Z",
    fill: "url(#paint0_radial_6813_5229)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9978 29.9978C25.3322 29.9978 29.9967 23.7303 29.9967 15.9989C29.9967 8.26751 25.3322 2 15.9978 2C6.66334 2 1.9989 8.26751 1.9989 15.9989C1.9989 23.7303 6.66334 29.9978 15.9978 29.9978Z",
    fill: "url(#paint1_radial_6813_5229)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9978 29.9978C25.3322 29.9978 29.9967 23.7303 29.9967 15.9989C29.9967 8.26751 25.3322 2 15.9978 2C6.66334 2 1.9989 8.26751 1.9989 15.9989C1.9989 23.7303 6.66334 29.9978 15.9978 29.9978Z",
    fill: "url(#paint2_radial_6813_5229)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9978 29.9978C25.3322 29.9978 29.9967 23.7303 29.9967 15.9989C29.9967 8.26751 25.3322 2 15.9978 2C6.66334 2 1.9989 8.26751 1.9989 15.9989C1.9989 23.7303 6.66334 29.9978 15.9978 29.9978Z",
    fill: "url(#paint3_radial_6813_5229)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9978 29.9978C25.3322 29.9978 29.9967 23.7303 29.9967 15.9989C29.9967 8.26751 25.3322 2 15.9978 2C6.66334 2 1.9989 8.26751 1.9989 15.9989C1.9989 23.7303 6.66334 29.9978 15.9978 29.9978Z",
    fill: "url(#paint4_radial_6813_5229)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9978 29.9978C25.3322 29.9978 29.9967 23.7303 29.9967 15.9989C29.9967 8.26751 25.3322 2 15.9978 2C6.66334 2 1.9989 8.26751 1.9989 15.9989C1.9989 23.7303 6.66334 29.9978 15.9978 29.9978Z",
    fill: "url(#paint5_radial_6813_5229)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9978 29.9978C25.3322 29.9978 29.9967 23.7303 29.9967 15.9989C29.9967 8.26751 25.3322 2 15.9978 2C6.66334 2 1.9989 8.26751 1.9989 15.9989C1.9989 23.7303 6.66334 29.9978 15.9978 29.9978Z",
    fill: "url(#paint6_radial_6813_5229)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9978 29.9978C25.3322 29.9978 29.9967 23.7303 29.9967 15.9989C29.9967 8.26751 25.3322 2 15.9978 2C6.66334 2 1.9989 8.26751 1.9989 15.9989C1.9989 23.7303 6.66334 29.9978 15.9978 29.9978Z",
    fill: "url(#paint7_radial_6813_5229)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.327 19C11.327 19 12.7286 21 15.9989 21C19.2692 21 20.6708 19 20.6708 19",
    stroke: "url(#paint8_radial_6813_5229)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6813_5229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.54846 14.596C3.76721 15.5023 4.39571 17.2239 6.40252 17.7207C6.70167 17.7948 6.99571 17.8486 7.29061 17.8892C7.30495 17.8912 7.31933 17.8929 7.33374 17.8942C11.6388 18.2977 14.4848 14.6586 14.6237 10.6995C14.6353 10.3714 14.8879 10.0939 15.2162 10.0896C15.391 10.0874 15.5723 10.0876 15.7589 10.0909C16.0859 10.0966 16.3368 10.3733 16.3484 10.7001C16.489 14.659 19.3323 18.2978 23.6382 17.8942C23.6526 17.8929 23.667 17.8912 23.6813 17.8892C23.9762 17.8486 24.2703 17.7948 24.5694 17.7207C27.228 17.0625 28.8773 15.3151 29.7207 13.4409C29.5899 12.648 29.4036 11.8798 29.1619 11.1426C28.9095 13.346 27.7297 13.6242 24.5694 14.4066C24.3093 14.471 23.4204 15.0907 23.1552 15.1273C20.1552 15.4085 19.3115 13.4409 17.611 10.2991L17.6108 10.2679C17.6108 10.2534 17.6109 10.239 17.6112 10.2246C17.7213 10.239 17.832 10.2547 17.943 10.2718L18.2166 8.49636C18.5328 8.08892 18.9554 7.76833 19.4429 7.57648C19.5575 7.527 19.8254 7.41453 20.6538 7.26008C21.5085 7.10072 23.7903 7.10254 25.1829 7.10366L25.4937 7.10383C26.229 7.10383 26.8968 7.31733 27.3281 7.51256C26.9758 7.02743 26.5879 6.56926 26.1645 6.14123C25.9446 6.11737 25.7194 6.10383 25.4937 6.10383L25.1791 6.10365C24.4851 6.1031 23.5571 6.10236 22.6939 6.12195C21.8577 6.14093 20.6189 6.19424 20.0982 6.29132C19.2373 6.45182 18.89 6.58041 18.689 6.66633C18.1361 6.88665 17.6613 7.22627 17.2865 7.65445C17.0401 7.93595 16.691 8.1239 16.3172 8.10734C15.7171 8.08075 15.1528 8.08379 14.6476 8.10426C14.2757 8.11932 13.9289 7.9321 13.6835 7.65224C13.309 7.22511 12.8349 6.88627 12.283 6.66633C12.0819 6.58041 11.7346 6.45182 10.8738 6.29132C10.3531 6.19424 9.11424 6.14093 8.27799 6.12195C7.41487 6.10236 6.48678 6.1031 5.79284 6.10365L5.77998 6.10366C5.44852 6.43576 5.13861 6.78621 4.85024 7.1535C5.05084 7.12236 5.26162 7.10383 5.47827 7.10383L5.78901 7.10366C7.18166 7.10254 9.46341 7.10072 10.3181 7.26008C11.1466 7.41453 11.4145 7.527 11.529 7.57648C11.9986 7.76126 12.4079 8.06548 12.7199 8.45169L13.0617 10.2662C13.1432 10.2509 13.2435 10.2346 13.3607 10.2182C13.3609 10.2348 13.3611 10.2513 13.3611 10.2679L13.3609 10.2991C13.5406 14.51 10.3337 17.048 7.33374 16.7668C7.06853 16.7302 6.80962 16.6826 6.5495 16.6182C4.25097 16.0491 4.41801 14.3606 3.76721 12.7523C3.65175 13.343 3.60081 13.9784 3.54846 14.596Z",
    fill: "url(#paint9_linear_6813_5229)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7959 5.66633C13.3479 5.88627 13.822 6.22511 14.1965 6.65224C14.4419 6.9321 14.7887 7.11932 15.1606 7.10426C15.6658 7.08379 16.2301 7.08075 16.8302 7.10734C17.204 7.1239 17.5531 6.93595 17.7995 6.65445C18.1743 6.22627 18.6491 5.88665 19.2019 5.66633C19.403 5.58041 19.7503 5.45182 20.6111 5.29132C21.1318 5.19424 22.3707 5.14093 23.2069 5.12195C24.07 5.10236 24.9981 5.1031 25.6921 5.10365L26.0066 5.10383C27.196 5.10383 28.3694 5.47962 28.8348 5.76008C29.8816 6.29133 30.8504 7.30695 30.9199 9.05467C30.9227 9.08081 30.9246 9.10715 30.9254 9.13366C31.0079 11.822 29.3385 15.667 25.0824 16.7207C24.7832 16.7948 24.4892 16.8486 24.1943 16.8892C24.18 16.8912 24.1656 16.8929 24.1512 16.8942C19.8453 17.2978 17.002 13.659 16.8614 9.70008C16.8498 9.37326 16.5989 9.09658 16.2719 9.09087C16.0853 9.08761 15.904 9.08738 15.7292 9.08963C15.4009 9.09387 15.1483 9.37138 15.1367 9.69951C14.9978 13.6586 12.1517 17.2977 7.84672 16.8942C7.83231 16.8929 7.81794 16.8912 7.8036 16.8892C7.5087 16.8486 7.21466 16.7948 6.91551 16.7207C2.65942 15.667 0.990014 11.822 1.07248 9.13366C1.07329 9.10715 1.07515 9.08081 1.07804 9.05467C1.14751 7.30695 2.11626 6.29133 3.16314 5.76008C3.62846 5.47962 4.80188 5.10383 5.99126 5.10383L6.30582 5.10365C6.99977 5.1031 7.92786 5.10236 8.79097 5.12195C9.62723 5.14093 10.866 5.19424 11.3867 5.29132C12.2476 5.45182 12.5949 5.58041 12.7959 5.66633ZM2.48946 8.165C2.73935 7.55637 3.20319 7.059 3.82764 6.68264C4.17876 6.47101 5.02691 6.10383 5.99126 6.10383L6.302 6.10366C7.69465 6.10254 9.97639 6.10072 10.8311 6.26008C11.6596 6.41453 11.9275 6.527 12.042 6.57648C12.5115 6.76126 12.9209 7.06548 13.2329 7.45169L13.5746 9.26624C13.6562 9.25089 13.7565 9.23455 13.8736 9.21825C13.8739 9.23476 13.8741 9.25131 13.8741 9.26789L13.8739 9.29909C14.0536 13.51 10.8467 16.048 7.84673 15.7668C7.58152 15.7302 7.32261 15.6826 7.06248 15.6182C3.9022 14.8358 2.57541 12.346 2.32299 10.1426C2.28412 9.80326 2.27072 9.47073 2.28004 9.15227L2.28031 9.14333L2.28232 9.1434L2.28269 9.13366C2.29661 8.78507 2.36759 8.4618 2.48946 8.165ZM18.1241 9.22462C18.1239 9.23902 18.1238 9.25344 18.1238 9.26789L18.124 9.29909C17.9443 13.51 21.1512 16.048 24.1512 15.7668C24.4164 15.7302 24.6753 15.6826 24.9354 15.6182C28.0957 14.8358 29.4225 12.346 29.6749 10.1426C29.7138 9.80326 29.7272 9.47073 29.7179 9.15227L29.7176 9.14333L29.7156 9.1434L29.7152 9.13366C29.7013 8.78507 29.6303 8.4618 29.5084 8.165C29.2585 7.55637 28.7947 7.059 28.1703 6.68264C27.8191 6.47101 26.971 6.10383 26.0066 6.10383L25.6959 6.10366C24.3032 6.10254 22.0215 6.10072 21.1668 6.26008C20.3383 6.41453 20.0704 6.527 19.9559 6.57648C19.4684 6.76833 19.0457 7.08892 18.7296 7.49636L18.456 9.27185C18.345 9.25474 18.2343 9.23902 18.1241 9.22462Z",
    fill: "url(#paint10_radial_6813_5229)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7959 5.66633C13.3479 5.88627 13.822 6.22511 14.1965 6.65224C14.4419 6.9321 14.7887 7.11932 15.1606 7.10426C15.6658 7.08379 16.2301 7.08075 16.8302 7.10734C17.204 7.1239 17.5531 6.93595 17.7995 6.65445C18.1743 6.22627 18.6491 5.88665 19.2019 5.66633C19.403 5.58041 19.7503 5.45182 20.6111 5.29132C21.1318 5.19424 22.3707 5.14093 23.2069 5.12195C24.07 5.10236 24.9981 5.1031 25.6921 5.10365L26.0066 5.10383C27.196 5.10383 28.3694 5.47962 28.8348 5.76008C29.8816 6.29133 30.8504 7.30695 30.9199 9.05467C30.9227 9.08081 30.9246 9.10715 30.9254 9.13366C31.0079 11.822 29.3385 15.667 25.0824 16.7207C24.7832 16.7948 24.4892 16.8486 24.1943 16.8892C24.18 16.8912 24.1656 16.8929 24.1512 16.8942C19.8453 17.2978 17.002 13.659 16.8614 9.70008C16.8498 9.37326 16.5989 9.09658 16.2719 9.09087C16.0853 9.08761 15.904 9.08738 15.7292 9.08963C15.4009 9.09387 15.1483 9.37138 15.1367 9.69951C14.9978 13.6586 12.1517 17.2977 7.84672 16.8942C7.83231 16.8929 7.81794 16.8912 7.8036 16.8892C7.5087 16.8486 7.21466 16.7948 6.91551 16.7207C2.65942 15.667 0.990014 11.822 1.07248 9.13366C1.07329 9.10715 1.07515 9.08081 1.07804 9.05467C1.14751 7.30695 2.11626 6.29133 3.16314 5.76008C3.62846 5.47962 4.80188 5.10383 5.99126 5.10383L6.30582 5.10365C6.99977 5.1031 7.92786 5.10236 8.79097 5.12195C9.62723 5.14093 10.866 5.19424 11.3867 5.29132C12.2476 5.45182 12.5949 5.58041 12.7959 5.66633ZM2.48946 8.165C2.73935 7.55637 3.20319 7.059 3.82764 6.68264C4.17876 6.47101 5.02691 6.10383 5.99126 6.10383L6.302 6.10366C7.69465 6.10254 9.97639 6.10072 10.8311 6.26008C11.6596 6.41453 11.9275 6.527 12.042 6.57648C12.5115 6.76126 12.9209 7.06548 13.2329 7.45169L13.5746 9.26624C13.6562 9.25089 13.7565 9.23455 13.8736 9.21825C13.8739 9.23476 13.8741 9.25131 13.8741 9.26789L13.8739 9.29909C14.0536 13.51 10.8467 16.048 7.84673 15.7668C7.58152 15.7302 7.32261 15.6826 7.06248 15.6182C3.9022 14.8358 2.57541 12.346 2.32299 10.1426C2.28412 9.80326 2.27072 9.47073 2.28004 9.15227L2.28031 9.14333L2.28232 9.1434L2.28269 9.13366C2.29661 8.78507 2.36759 8.4618 2.48946 8.165ZM18.1241 9.22462C18.1239 9.23902 18.1238 9.25344 18.1238 9.26789L18.124 9.29909C17.9443 13.51 21.1512 16.048 24.1512 15.7668C24.4164 15.7302 24.6753 15.6826 24.9354 15.6182C28.0957 14.8358 29.4225 12.346 29.6749 10.1426C29.7138 9.80326 29.7272 9.47073 29.7179 9.15227L29.7176 9.14333L29.7156 9.1434L29.7152 9.13366C29.7013 8.78507 29.6303 8.4618 29.5084 8.165C29.2585 7.55637 28.7947 7.059 28.1703 6.68264C27.8191 6.47101 26.971 6.10383 26.0066 6.10383L25.6959 6.10366C24.3032 6.10254 22.0215 6.10072 21.1668 6.26008C20.3383 6.41453 20.0704 6.527 19.9559 6.57648C19.4684 6.76833 19.0457 7.08892 18.7296 7.49636L18.456 9.27185C18.345 9.25474 18.2343 9.23902 18.1241 9.22462Z",
    fill: "url(#paint11_radial_6813_5229)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7959 5.66633C13.3479 5.88627 13.822 6.22511 14.1965 6.65224C14.4419 6.9321 14.7887 7.11932 15.1606 7.10426C15.6658 7.08379 16.2301 7.08075 16.8302 7.10734C17.204 7.1239 17.5531 6.93595 17.7995 6.65445C18.1743 6.22627 18.6491 5.88665 19.2019 5.66633C19.403 5.58041 19.7503 5.45182 20.6111 5.29132C21.1318 5.19424 22.3707 5.14093 23.2069 5.12195C24.07 5.10236 24.9981 5.1031 25.6921 5.10365L26.0066 5.10383C27.196 5.10383 28.3694 5.47962 28.8348 5.76008C29.8816 6.29133 30.8504 7.30695 30.9199 9.05467C30.9227 9.08081 30.9246 9.10715 30.9254 9.13366C31.0079 11.822 29.3385 15.667 25.0824 16.7207C24.7832 16.7948 24.4892 16.8486 24.1943 16.8892C24.18 16.8912 24.1656 16.8929 24.1512 16.8942C19.8453 17.2978 17.002 13.659 16.8614 9.70008C16.8498 9.37326 16.5989 9.09658 16.2719 9.09087C16.0853 9.08761 15.904 9.08738 15.7292 9.08963C15.4009 9.09387 15.1483 9.37138 15.1367 9.69951C14.9978 13.6586 12.1517 17.2977 7.84672 16.8942C7.83231 16.8929 7.81794 16.8912 7.8036 16.8892C7.5087 16.8486 7.21466 16.7948 6.91551 16.7207C2.65942 15.667 0.990014 11.822 1.07248 9.13366C1.07329 9.10715 1.07515 9.08081 1.07804 9.05467C1.14751 7.30695 2.11626 6.29133 3.16314 5.76008C3.62846 5.47962 4.80188 5.10383 5.99126 5.10383L6.30582 5.10365C6.99977 5.1031 7.92786 5.10236 8.79097 5.12195C9.62723 5.14093 10.866 5.19424 11.3867 5.29132C12.2476 5.45182 12.5949 5.58041 12.7959 5.66633ZM2.48946 8.165C2.73935 7.55637 3.20319 7.059 3.82764 6.68264C4.17876 6.47101 5.02691 6.10383 5.99126 6.10383L6.302 6.10366C7.69465 6.10254 9.97639 6.10072 10.8311 6.26008C11.6596 6.41453 11.9275 6.527 12.042 6.57648C12.5115 6.76126 12.9209 7.06548 13.2329 7.45169L13.5746 9.26624C13.6562 9.25089 13.7565 9.23455 13.8736 9.21825C13.8739 9.23476 13.8741 9.25131 13.8741 9.26789L13.8739 9.29909C14.0536 13.51 10.8467 16.048 7.84673 15.7668C7.58152 15.7302 7.32261 15.6826 7.06248 15.6182C3.9022 14.8358 2.57541 12.346 2.32299 10.1426C2.28412 9.80326 2.27072 9.47073 2.28004 9.15227L2.28031 9.14333L2.28232 9.1434L2.28269 9.13366C2.29661 8.78507 2.36759 8.4618 2.48946 8.165ZM18.1241 9.22462C18.1239 9.23902 18.1238 9.25344 18.1238 9.26789L18.124 9.29909C17.9443 13.51 21.1512 16.048 24.1512 15.7668C24.4164 15.7302 24.6753 15.6826 24.9354 15.6182C28.0957 14.8358 29.4225 12.346 29.6749 10.1426C29.7138 9.80326 29.7272 9.47073 29.7179 9.15227L29.7176 9.14333L29.7156 9.1434L29.7152 9.13366C29.7013 8.78507 29.6303 8.4618 29.5084 8.165C29.2585 7.55637 28.7947 7.059 28.1703 6.68264C27.8191 6.47101 26.971 6.10383 26.0066 6.10383L25.6959 6.10366C24.3032 6.10254 22.0215 6.10072 21.1668 6.26008C20.3383 6.41453 20.0704 6.527 19.9559 6.57648C19.4684 6.76833 19.0457 7.08892 18.7296 7.49636L18.456 9.27185C18.345 9.25474 18.2343 9.23902 18.1241 9.22462Z",
    fill: "url(#paint12_radial_6813_5229)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82766 6.68264C4.17878 6.47101 5.02694 6.10382 5.99128 6.10382C6.08862 6.10382 6.19258 6.10374 6.30203 6.10365C7.69467 6.10254 9.97642 6.10072 10.8311 6.26007C11.6596 6.41453 11.9275 6.527 12.0421 6.57648C13.1151 6.99878 13.8741 8.04494 13.8741 9.26789L13.8739 9.29909C14.0536 13.51 10.8468 16.048 7.84675 15.7668C7.58154 15.7302 7.32263 15.6826 7.06251 15.6182C3.41076 14.7141 2.20711 11.5303 2.28034 9.14289L2.28235 9.1434C2.32168 8.0753 2.89586 7.24425 3.82766 6.68264Z",
    fill: "url(#paint13_radial_6813_5229)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82766 6.68264C4.17878 6.47101 5.02694 6.10382 5.99128 6.10382C6.08862 6.10382 6.19258 6.10374 6.30203 6.10365C7.69467 6.10254 9.97642 6.10072 10.8311 6.26007C11.6596 6.41453 11.9275 6.527 12.0421 6.57648C13.1151 6.99878 13.8741 8.04494 13.8741 9.26789L13.8739 9.29909C14.0536 13.51 10.8468 16.048 7.84675 15.7668C7.58154 15.7302 7.32263 15.6826 7.06251 15.6182C3.41076 14.7141 2.20711 11.5303 2.28034 9.14289L2.28235 9.1434C2.32168 8.0753 2.89586 7.24425 3.82766 6.68264Z",
    fill: "url(#paint14_radial_6813_5229)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82766 6.68264C4.17878 6.47101 5.02694 6.10382 5.99128 6.10382C6.08862 6.10382 6.19258 6.10374 6.30203 6.10365C7.69467 6.10254 9.97642 6.10072 10.8311 6.26007C11.6596 6.41453 11.9275 6.527 12.0421 6.57648C13.1151 6.99878 13.8741 8.04494 13.8741 9.26789L13.8739 9.29909C14.0536 13.51 10.8468 16.048 7.84675 15.7668C7.58154 15.7302 7.32263 15.6826 7.06251 15.6182C3.41076 14.7141 2.20711 11.5303 2.28034 9.14289L2.28235 9.1434C2.32168 8.0753 2.89586 7.24425 3.82766 6.68264Z",
    fill: "url(#paint15_radial_6813_5229)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82766 6.68264C4.17878 6.47101 5.02694 6.10382 5.99128 6.10382C6.08862 6.10382 6.19258 6.10374 6.30203 6.10365C7.69467 6.10254 9.97642 6.10072 10.8311 6.26007C11.6596 6.41453 11.9275 6.527 12.0421 6.57648C13.1151 6.99878 13.8741 8.04494 13.8741 9.26789L13.8739 9.29909C14.0536 13.51 10.8468 16.048 7.84675 15.7668C7.58154 15.7302 7.32263 15.6826 7.06251 15.6182C3.41076 14.7141 2.20711 11.5303 2.28034 9.14289L2.28235 9.1434C2.32168 8.0753 2.89586 7.24425 3.82766 6.68264Z",
    fill: "url(#paint16_radial_6813_5229)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.1381,
    cy: 9.14289,
    rx: 1.49418,
    ry: 1.8791,
    transform: "rotate(-25.8832 11.1381 9.14289)",
    fill: "url(#paint17_linear_6813_5229)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1703 6.68264C27.8191 6.47101 26.971 6.10382 26.0066 6.10382C25.9093 6.10382 25.8053 6.10374 25.6959 6.10365C24.3032 6.10254 22.0215 6.10072 21.1668 6.26007C20.3383 6.41453 20.0704 6.527 19.9559 6.57648C18.8828 6.99878 18.1238 8.04494 18.1238 9.26789L18.124 9.29909C17.9443 13.51 21.1512 16.048 24.1512 15.7668C24.4164 15.7302 24.6753 15.6826 24.9354 15.6182C28.5872 14.7141 29.7908 11.5303 29.7176 9.14289L29.7156 9.1434C29.6762 8.0753 29.1021 7.24425 28.1703 6.68264Z",
    fill: "url(#paint18_radial_6813_5229)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1703 6.68264C27.8191 6.47101 26.971 6.10382 26.0066 6.10382C25.9093 6.10382 25.8053 6.10374 25.6959 6.10365C24.3032 6.10254 22.0215 6.10072 21.1668 6.26007C20.3383 6.41453 20.0704 6.527 19.9559 6.57648C18.8828 6.99878 18.1238 8.04494 18.1238 9.26789L18.124 9.29909C17.9443 13.51 21.1512 16.048 24.1512 15.7668C24.4164 15.7302 24.6753 15.6826 24.9354 15.6182C28.5872 14.7141 29.7908 11.5303 29.7176 9.14289L29.7156 9.1434C29.6762 8.0753 29.1021 7.24425 28.1703 6.68264Z",
    fill: "url(#paint19_radial_6813_5229)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1703 6.68264C27.8191 6.47101 26.971 6.10382 26.0066 6.10382C25.9093 6.10382 25.8053 6.10374 25.6959 6.10365C24.3032 6.10254 22.0215 6.10072 21.1668 6.26007C20.3383 6.41453 20.0704 6.527 19.9559 6.57648C18.8828 6.99878 18.1238 8.04494 18.1238 9.26789L18.124 9.29909C17.9443 13.51 21.1512 16.048 24.1512 15.7668C24.4164 15.7302 24.6753 15.6826 24.9354 15.6182C28.5872 14.7141 29.7908 11.5303 29.7176 9.14289L29.7156 9.1434C29.6762 8.0753 29.1021 7.24425 28.1703 6.68264Z",
    fill: "url(#paint20_radial_6813_5229)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1703 6.68264C27.8191 6.47101 26.971 6.10382 26.0066 6.10382C25.9093 6.10382 25.8053 6.10374 25.6959 6.10365C24.3032 6.10254 22.0215 6.10072 21.1668 6.26007C20.3383 6.41453 20.0704 6.527 19.9559 6.57648C18.8828 6.99878 18.1238 8.04494 18.1238 9.26789L18.124 9.29909C17.9443 13.51 21.1512 16.048 24.1512 15.7668C24.4164 15.7302 24.6753 15.6826 24.9354 15.6182C28.5872 14.7141 29.7908 11.5303 29.7176 9.14289L29.7156 9.1434C29.6762 8.0753 29.1021 7.24425 28.1703 6.68264Z",
    fill: "url(#paint21_radial_6813_5229)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.1723,
    cy: 9.14289,
    rx: 1.49418,
    ry: 1.8791,
    transform: "rotate(-25.8832 27.1723 9.14289)",
    fill: "url(#paint22_linear_6813_5229)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6813_5229",
    x: 2.34846,
    y: 4.90345,
    width: 28.5722,
    height: 14.2215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6,
    result: "effect1_foregroundBlur_6813_5229"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.4989 9) rotate(132.839) scale(37.5033)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.4989 9) rotate(131.878) scale(38.9487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9989 12.5) rotate(101.31) scale(17.8466 22.8581)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.787821,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972509,
    stopColor: "#FF7DCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.9989 14) rotate(135) scale(41.0122)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314853,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9989 17) rotate(77.692) scale(28.1469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507903,
    stopColor: "#7D6133",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4989 16.5) rotate(55.7131) scale(13.3135 9.65032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB847",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.4989 18) rotate(9.86581) scale(11.6726)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.900412,
    stopColor: "#FFAE46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.4989 15) rotate(43.9708) scale(59.0529)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185425,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9989 17.8147) rotate(90) scale(10.9375 16.8684)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145833,
    stopColor: "#2E1529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "#503A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342857,
    stopColor: "#4B2744"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6813_5229",
    x1: 22.6865,
    y1: 12.0142,
    x2: 8.62399,
    y2: 17.3773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E78F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D07000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1238 5.75226) rotate(78.8614) scale(12.2941 25.4762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C3085"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.8896 11.0134) rotate(78.0636) scale(5.51431 6.19479)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#77579C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#77579C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8738 10.0023) rotate(-122.735) scale(4.68093 3.43606)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.769354,
    stopColor: "#4E3D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#534687",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.6865 9.06476) rotate(121.845) scale(5.92276 6.72838)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#361C5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.46785 9.22101) rotate(87.1376) scale(7.50937 11.1509)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.647365,
    stopColor: "#5B2B84",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B2B84"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.78035 16.7835) rotate(-99.5134) scale(11.5336 11.4216)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.858612,
    stopColor: "#2E1D57",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20143D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.7491 8.47101) rotate(102.225) scale(7.67402 7.20221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.872281,
    stopColor: "#2E1D57",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20143D",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6813_5229",
    x1: 11.7919,
    y1: 7.79545,
    x2: 10.3984,
    y2: 10.9574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6552 8.65851) rotate(121.289) scale(6.61888 9.94211)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#361C5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5301 9.22101) rotate(92.8624) scale(7.50937 11.1509)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.647365,
    stopColor: "#5B2B84",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B2B84"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.9187 15.4398) rotate(-77.6023) scale(10.2708 10.171)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.858612,
    stopColor: "#2E1D57",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20143D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_6813_5229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.2488 8.47101) rotate(77.7749) scale(7.67402 7.20221)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.872281,
    stopColor: "#2E1D57",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20143D",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6813_5229",
    x1: 27.8261,
    y1: 7.79545,
    x2: 26.4326,
    y2: 10.9574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNice);
export default __webpack_public_path__ + "static/media/nice.e057ff9fd5fe9526f7d08e670cefa1c3.svg";
export { ForwardRef as ReactComponent };